<template>
	<div>
		<div v-if="form" class="modal_form">
			<div v-if="payload.is_create">
				<env-chooser v-model="form.data.company.fields.env.value" :has_error="form.data.company.fields.env.has_error"></env-chooser>
			</div>
				<div class="vertical_space"></div>
			<div>
				<p class="bold">שם חברה</p>
				<input type="text" v-model="form.data.company.fields.name.value" 
					   :class="{ field_error: form.data.company.fields.name.has_error }"
					   @focus="form.data.company.fields.name.has_error = false">
			</div>
			<div>
				<checkbox v-model="form.data.company.fields.is_discreet.value" :checked="form.data.company.fields.is_discreet.value">
					Is Discreet
				</checkbox>
			</div>
			<div class="form_section">
				<checkbox v-model="form.data.company.fields.has_contract.value" :checked="form.data.company.fields.has_contract.value">
					Has Contract
				</checkbox>
			</div>
			<div class="form_section">
				<p class="bold">אחוז משרה</p>
				<input type="text" v-model="form.data.company.fields.percentage.value" 
					   :class="{ field_error: form.data.company.fields.percentage.has_error }"
					   @focus="form.data.company.fields.percentage.has_error = false">
			</div>
			<div class="form_section">
				<p class="bold">הודעה</p>
				<textarea type="text" v-model="form.data.company.fields.message.value">
				</textarea>
			</div>
			<div class="form_section">
				<p class="bold">ימים לדרישת תשלום</p>
				<input type="text" v-model="form.data.company.fields.maturation_days.value" 
					   :class="{ field_error: form.data.company.fields.maturation_days.has_error }"
					   @focus="form.data.company.fields.maturation_days.has_error = false">
			</div>
			<div class="form_section">
				<p class="bold">אימייל</p>
				<textarea class="text_align_left" style="direction: ltr" type="text" v-model="form.data.company.fields.email.value" 
					   :class="{ field_error: form.data.company.fields.email.has_error }"
					   @focus="form.data.company.fields.email.has_error = false">
				</textarea>
			</div>
			<div class="form_section">
				<p class="bold">פרטי יצירת קשר</p>
				<textarea type="text" v-model="form.data.company.fields.contact_details.value">
				</textarea>
			</div>
		</div>
		<div class="modal_footer flex_justify_between">
			<a
				@click="submit()"
				:class="{ 'is-loading': is_loading }"
				class="button is-info"
				>Submit</a
			>
			<div v-if="!payload.is_create">
				<router-link :to="{ name: 'offers', query: { company_id: payload.data.id, company_name: payload.data.name } }" 
							 class="button is-info is-outlined">
					Offers
				</router-link>
			</div>
		</div>
	</div>
</template>
<script>
	import { mapMutations, mapActions } from 'vuex'
	import Validator from '@/classes/validator.js'
	import EnvChooser from '@/components/EnvChooser'
	import Checkbox from '@/components/Checkbox'
	export default {
		name: 'company-form',
		props: ['payload'],
		data(){
			return {
				is_loading: false,
				form: undefined,
				validator: new Validator()
			}
		},
		created(){
			this.init()
		},
		methods: {
			init(){
				if (this.payload.is_create) {
					this.setForm({
					  id: '',
					})
					return
				}
				this.$network_utils.getCompany(this.payload.data.id).then(response => {
					this.setForm(response)
				})
			},
		    setForm (form_data) {
		      this.form = new this.$form({
		        company: {
		          fields: {
		            name: {
		              value: form_data.name,
		              has_error: false,
		              validations: ['Exists']
		            },
		            is_discreet: {
		              value: form_data.is_discreet,
		              has_error: false,
		              validations: []
		            },
		            has_contract: {
		              value: form_data.has_contract,
		              has_error: false,
		              validations: []
		            },
		            percentage: {
		              value: form_data.percentage,
		              has_error: false,
		              validations: ['Exists', 'Number']
		            },
		            message: {
		              value: form_data.message,
		              has_error: false,
		              validations: []
		            },
		            maturation_days: {
		              value: form_data.maturation_days,
		              has_error: false,
		              validations: ['Number']
		            },
		            email: {
		              value: form_data.email,
		              has_error: false,
		              validations: ['Exists']
		            },
		            contact_details: {
		              value: form_data.contact_details,
		              has_error: false,
		              validations: []
		            },
		          },
		          request_details: {
		            method: this.payload.is_create ? 'post' : 'put',
		            url: '/companies/' + form_data.id,
		          },
		          is_used: true
		        }
		      })
		      if(this.payload.is_create){
		      	this.form.data.company.fields.env = {
	              value: '',
	              has_error: false,
	              validations: ['Exists']
	            }
		      }
		    },
		    submit () {
		    	let email = this.form.data.company.fields.email.value
		    	if(email != undefined && !this.validator.multipleEmailsValidationSanity(email)){
		    		return
		    	}
				let response = this.form.mySubmit()
				if (response === false) {
					return
				}
				this.is_loading = true
				response.promise.then((response) => {
					this.showToast('עודכן בהצלחה')
					this.is_loading = false
					this.removeModal(this.payload)
				}).catch(() => {
					this.is_loading = false
					this.showToast('ארעה שגיאה - כנראה שהחברה כבר קיימת במערכת')
				})
		    },
				...mapActions('toasts', ['showToast']),
		    ...mapMutations('modals', ['removeModal'])
		},
		components: {
			EnvChooser,
			Checkbox
		}
	}
</script>